import { useState } from "react";
import { roastPosts } from "@/mocks/guage";

const categories = ["全部", "综艺观察", "热点复盘", "影视吐槽", "名场面", "星光造型"];

export default function RoastSection() {
  const [filter, setFilter] = useState("全部");
  const list = filter === "全部" ? roastPosts : roastPosts.filter((p) => p.category === filter);
  const [lead, ...rest] = list.length > 0 ? list : roastPosts;

  return (
    <section id="roast" className="w-full bg-background-100 melon-grid py-16 md:py-24">
      <div className="w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
          <div>
            <span className="inline-flex items-center gap-2 text-primary-700 text-xs md:text-sm font-medium">
              <span className="w-6 h-px bg-primary-500"></span>
              瓜榜热度排行
            </span>
            <h2 className="mt-4 font-heading text-3xl md:text-5xl text-foreground-950">
              热门神点评
            </h2>
            <p className="mt-3 max-w-xl text-sm md:text-base text-foreground-600 leading-relaxed">
              按瓜友讨论热度实时排序，每篇都配好时间线与逐句拆解。点开分类，只看你想看的那一口。
            </p>
          </div>

          <div className="flex flex-wrap gap-2">
            {categories.map((cat) => (
              <button
                key={cat}
                type="button"
                onClick={() => setFilter(cat)}
                className={`px-4 py-2 rounded-full text-xs md:text-sm whitespace-nowrap border transition-colors cursor-pointer ${
                  filter === cat
                    ? "bg-primary-500 border-primary-500 text-background-50"
                    : "bg-background-50 border-background-300 text-foreground-700 hover:border-primary-300 hover:text-primary-600"
                }`}
              >
                {cat}
              </button>
            ))}
          </div>
        </div>

        {lead && (
          <article className="mt-9 md:mt-12 grid grid-cols-1 lg:grid-cols-2 gap-0 rounded-lg overflow-hidden bg-background-50 border border-background-200">
            <div className="relative h-56 sm:h-72 lg:h-full lg:min-h-[360px]">
              <img
                src={lead.cover}
                alt={`${lead.title} 配图`}
                title={`${lead.title} · 瓜哥吃瓜`}
                className="w-full h-full object-cover object-top"
              />
              <span className="absolute top-4 left-4 flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-primary-500 text-background-50 text-xs font-medium">
                <i className="ri-fire-fill"></i>
                热度第一
              </span>
            </div>
            <div className="p-6 md:p-9 flex flex-col">
              <div className="flex items-center gap-3 text-xs text-foreground-500">
                <span className="px-2.5 py-1 rounded-md bg-secondary-100 text-secondary-800 whitespace-nowrap">
                  {lead.category}
                </span>
                <span>{lead.date}</span>
              </div>
              <h3 className="mt-4 font-heading text-2xl md:text-4xl leading-snug text-foreground-950">
                {lead.title}
              </h3>
              <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
                {lead.summary}
              </p>
              <div className="mt-5 flex flex-wrap gap-2">
                {lead.tags.map((tag) => (
                  <span
                    key={tag}
                    className="px-2.5 py-1 rounded-md bg-accent-100 text-accent-800 text-xs whitespace-nowrap"
                  >
                    #{tag}
                  </span>
                ))}
              </div>
              <div className="mt-auto pt-6 flex items-center justify-between">
                <div className="flex items-center gap-2 text-xs text-foreground-500">
                  <i className="ri-chat-smile-2-line text-primary-500"></i>
                  {lead.heat} 人围观
                  <span className="text-foreground-300">·</span>
                  {lead.read}
                </div>
                <a
                  href="#feature"
                  className="flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
                >
                  看点评
                  <i className="ri-arrow-right-up-line"></i>
                </a>
              </div>
            </div>
          </article>
        )}

        <div className="mt-4 md:mt-5 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {rest.map((post, index) => (
            <article
              key={post.id}
              className="flex flex-col rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-primary-300 transition-colors"
            >
              <div className="relative h-44 md:h-48">
                <img
                  src={post.cover}
                  alt={`${post.title} 配图`}
                  title={`${post.title} · 瓜哥吃瓜`}
                  className="w-full h-full object-cover object-top"
                />
                <span className="absolute top-3 right-3 font-heading text-2xl w-10 h-10 flex items-center justify-center rounded-md bg-background-50/90 text-primary-600">
                  {String(roastPosts.indexOf(post) + 1).padStart(2, "0")}
                </span>
                <span className="absolute bottom-3 left-3 px-2.5 py-1 rounded-md bg-foreground-950/75 text-background-50 text-xs whitespace-nowrap">
                  {post.category}
                </span>
              </div>
              <div className="flex flex-col flex-1 p-4 md:p-5">
                <h3 className="font-heading text-lg md:text-xl leading-snug text-foreground-950">
                  {post.title}
                </h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-3">
                  {post.summary}
                </p>
                <div className="mt-auto pt-4 flex items-center justify-between text-xs text-foreground-500">
                  <span className="flex items-center gap-1.5">
                    <i className="ri-eye-line text-accent-600"></i>
                    {post.heat}
                  </span>
                  <span>{post.date.slice(5)}</span>
                </div>
              </div>
            </article>
          ))}
        </div>

        {list.length === 0 && (
          <p className="mt-10 text-center text-sm text-foreground-500">
            这个分类暂时还没有拆好的瓜，先看看其他分类吧。
          </p>
        )}
      </div>
    </section>
  );
}